
// polyfills
import 'babel-polyfill';
import 'element-closest';
import './polyfill';

import './windowExports';

// source
import './web';
import './configureWeb';
import './configurePartialUpdate';

// css
import '../css-scss/main.scss';



// WEBPACK FOOTER //
// ./fe/web-career/src/js/index.js